import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appOnlyalphabet]'
})
export class OnlyAlphabetDirective {

    constructor(private el: ElementRef) { }

    @HostListener('keydown', ['$event'])
    onKeydown(event: KeyboardEvent) {
        const key = event.key;

        // Allow letters, spaces, backspace, tab, enter, arrow keys
        if (/^[a-zA-Z ]$/.test(key) ||
            key === 'Backspace' ||
            key === 'Tab' ||
            key === 'Enter' ||
            key === 'ArrowLeft' ||
            key === 'ArrowRight' ||
            key === 'ArrowUp' ||
            key === 'ArrowDown') {
            return; // Allow these keys
        }

        // Prevent other characters
        event.preventDefault();
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        const clipboardData = event.clipboardData?.getData('text') ?? '';
        const sanitized = clipboardData.replace(/[^a-zA-Z ]+/g, '');

        if (sanitized !== clipboardData) {
            event.preventDefault();
            const input = this.el.nativeElement as HTMLInputElement;
            const start = input.selectionStart ?? input.value.length;
            const end = input.selectionEnd ?? input.value.length;
            input.value = input.value.slice(0, start) + sanitized + input.value.slice(end);
        }
    }
}
